import React from "react";
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  Grid,
  Alert
} from '@mui/material';

const InfoPage = () => {
  return (
    <Container sx={{ py: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Information
        </Typography>
        <Typography variant="body1" color="text.secondary">
          General information about the Walkmore platform
        </Typography>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                About Walkmore
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Walkmore is a fitness tracking platform that helps you stay active and compete with friends through step challenges.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Features
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Connect devices, track steps, join challenges, and compete with friends in a fun and engaging way.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12}>
          <Alert severity="info">
            This is a placeholder page. More detailed information and features will be added when the backend is fully deployed.
          </Alert>
        </Grid>
      </Grid>
    </Container>
  );
};

export default InfoPage;
